export enum RequestSMSPurchaseStatus {
  ALL = '',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  PAID = 'PAID',
}

export const RequestSMSPurchaseStatusOptions = [
  { label: 'All Status', value: RequestSMSPurchaseStatus.ALL },
  { label: 'Pending', value: RequestSMSPurchaseStatus.PENDING },
  { label: 'Approved', value: RequestSMSPurchaseStatus.APPROVED },
  { label: 'Canceled', value: RequestSMSPurchaseStatus.CANCELED },
  { label: 'Paid', value: RequestSMSPurchaseStatus.PAID },
];

export interface ISummaryRequestSMSParams {
  shopId?: string;
  status?: string;
  startDate: string;
  endDate: string;
}

export interface IRequestSMSPurchaseParams {
  shopId?: string;
  status?: string;
  page: number;
  size: number;
  startDate: string;
  endDate: string;
}

export interface ISummaryVoiceParams {
  shopId?: string;
  startDate?: string;
  endDate?: string;
}

export interface IReportVoiceParams {
  shopId?: string;
  startDate?: string;
  endDate?: string;
  page: number;
  size: number;
}

export interface PageableSort {
  sorted: boolean;
  empty: boolean;
  unsorted: boolean;
}

export interface PageableInfo {
  sort: PageableSort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  unpaged: boolean;
  paged: boolean;
}

export interface IResponseDataTable<T> {
  totalElements: number;
  totalPages: number;
  pageable: PageableInfo;
  content: T[];
}

export interface IRequestSMSPurchase {
  id: string;
  shopId: string;
  createdDate: string;
  amount: number;
  note: string;
  type: string;
  approvedDate: string | null;
  paidDate: string | null;
  status: string;
  businessName: string;
  phone: string;
}

export interface IReportVoice {
  shopId: string;
  email: string;
  businessName: string;
  phone: string;
  totalVoice: number;
  totalCost: number;
  address: string;
}

export interface IGetSummaryReportVoiceResponse {
  totalCost: number;
  totalVoice: number;
}

export interface IReportSMS {
  shopId: string;
  email: string;
  shopName: string;
  totalSent: number;
  totalOtp: number;
  totalMarketing: number;
  totalAppointment: number;
  totalOthers: number;
  totalSuccess: number;
  totalFail: number;
  totalCost: number;
}

export interface IGetSummaryReportSMSResponse {
  totalCost: number;
  totalOtp: number;
  totalMarketing: number;
  totalAppointment: number;
  totalOthers: number;
}

export interface IGetSummaryRequestSMSResponse {
  totalRequest: number;
  totalApproved: number;
  totalCancelled: number;
  totalPending: number;
  totalCost: number;
  costPending: number;
  costApproved: number;
  costCancelled: number;
}

export interface IStore {
  accountId: string;
  accountName: string;
  email: string;
  createdDate: string;
  shopId: string;
  shopName: string;
  phoneShop: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
}
